/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable operator-linebreak */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-confusing-arrow */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
import React, { useState, useEffect } from "react";

import { NavigateFunction, useNavigate } from "react-router-dom";

import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Typography from "@mui/material/Typography";

import {
    CAREER_TYPE_ELEARNING,
    CAREER_TYPE_CLASSROOM,
    CAREER_STATUS_APPLYING_ATTEND,
    CAREER_STATUS_APPLYING_CANCEL,
    CAREER_STATUS_APPLYING_RECORD,
    CAREER_STATUS_APPLYING_EXECUTE,
    CAREER_STATUS_LEARNING,
    CAREER_STATUS_DOING,
    CAREER_STATUS_UNLEARNED,
    CareerStatuses,
    CareerStatusType,
} from "../../../../Constants";

import SompoHistoryCarousel, { ROWS } from "./SompoHistoryCarousel";
import NoData from "../../../../component/NoData";
import CareerCard from "../../../../component/card/CareerCard";
import { useScreenSize } from "../../../../component/Theme";
import SompoCardContent from "../../../../component/card/SompoCardContent";
import SompoProgressBar from "../../../../component/progress/SompoProgressBar";
import SompoDeadlineAlert from "../../../../component/alert/SompoDeadlineAlert";
import { calcDotsHeight } from "../../../../component/ReactSlickSettings";
import FilterTag, { ALL_CONDITION } from "../../../../component/filter/FilterTag";
import ConditionList from "../../../../component/ConditionList";
import SompoLoading from "../../../../component/loading/SompoLoading";
import type { Histories } from "../../Home";

import { OnGoingGridListItem } from "../../../../logic/api/OnGoingGridListService";
import { DateFormats, formatPeriod, parseJSDateTime } from "../../../../logic/datetime";
import { asc, descDate, chainedSort } from "../../../../logic/utility/sort";
import { Categories, CATEGORY_ID_CAREERS } from "../../../../logic/hook/useCategories";
import { alertDays, statusMatches } from "../../../../logic/utility/TrainingUtil";
import SompoContext from "../../../../logic/context/SompoContext";
import ScrollableGrid from "./ScrollableGrid";
import { sortByRequired } from "../../../../logic/utility/isRequired";

// モバイル版：カルーセルの表示内容を作成
const toMobileCards = (careers: OnGoingGridListItem[], navigate: NavigateFunction) => {
    // PC版は何もしない
    const { desktop } = useScreenSize();
    if (desktop) return [<></>];

    // カルーセルのスライド + カード作成
    const slideCards: React.JSX.Element[] = [];
    careers.forEach((career) => {
        const el = career.careerTypeId === CAREER_TYPE_ELEARNING;
        const gt = career.careerTypeId === CAREER_TYPE_CLASSROOM;
        const { alertView, remainingDays } = alertDays(career);
        slideCards.push(
            <Paper
                elevation={1}
                sx={{
                    mx: 1,
                    mb: 1,
                    pb: 1,
                    width: { xs: "160px", sx: "160px", md: "215px" },
                    minWidth: { xs: "160px", sx: "160px", md: "215px" },
                    maxWidth: { xs: "160px", sx: "160px", md: "215px" },
                    height: "fit-content",
                    direction: "column",
                }}
                key={`Home-OnGoing-Career-Card-Paper-${career.careerId}`}
            >
                <CareerCard
                    height="305px"
                    key={`Home-OnGoing-Career-Card-${career.careerId}`}
                    thumbnail={career.careerImageUrl}
                    tooltip={career.careerTitle}
                    badge={career.compulsoryId}
                    onClick={() => {
                        navigate(`/training/detail/${career.careerId}`, {
                            state: { check: false, showCertification: true, classId: career.classId },
                        });
                    }}
                >
                    <SompoCardContent
                        sx={{
                            display: "flex",
                            gap: 0.4,
                            flexFlow: "column",
                            justifyContent: "flex-start",
                            textAlign: "left",
                        }}
                    >
                        <Box />
                        <Typography
                            sx={{
                                width: "100%",
                                fontSize: "1rem",
                                fontWeight: "bold",
                                minHeight: "2lh",
                                wordBreak: "break-all",
                                overflowX: "hidden",
                            }}
                            className="ellipses2"
                        >
                            {career.careerTitle}
                        </Typography>
                        <SompoDeadlineAlert nearDeadline={alertView} diffDays={remainingDays} />
                        <Typography
                            variant="body2"
                            sx={{
                                fontWeight: alertView ? "bold" : "normal",
                                minHeight: "2.2em",
                            }}
                        >
                            {formatPeriod(career.jissiKikan)}
                        </Typography>
                        {el && <Typography variant="body2">eラーニング</Typography>}
                        {gt && <Typography variant="body2">集合研修</Typography>}
                        {gt && (
                            <Typography className="ellipses" variant="body2" sx={{ wordBreak: "break-all", overflowX: "hidden" }}>
                                {career.classroom}
                            </Typography>
                        )}
                        {el && <SompoProgressBar progress={career.progress} />}
                    </SompoCardContent>
                </CareerCard>
            </Paper>
        );
    });

    return slideCards;
};

const filterByCategory = (career: OnGoingGridListItem, categories: Categories, filterValue: string): boolean => {
    // ALL
    if (filterValue === ALL_CONDITION.id) return true;

    // カテゴリ選択あり
    const { getTargetCategory } = categories;
    const topCategories = getTargetCategory(career.careerId);
    return filterValue === (topCategories?.id as string);
};
const filterByStatus = (career: OnGoingGridListItem, filterValue: string): boolean => {
    const { status = "" } = career;

    switch (filterValue) {
        case CareerStatusType.APPLYING: // 申請中
            // 受講申請中・取消申請中・実績申請中
            return statusMatches(status, [
                CareerStatuses[CAREER_STATUS_APPLYING_ATTEND], // 受講申請中
                CareerStatuses[CAREER_STATUS_APPLYING_EXECUTE], // 実施申請中(受講申請中として扱う)
                CareerStatuses[CAREER_STATUS_APPLYING_CANCEL], // 取消申請中
                CareerStatuses[CAREER_STATUS_APPLYING_RECORD], // 実績申請中
            ]);
        case CareerStatusType.DOING: // 実施中
            // 未学習・学習中・実施中
            return statusMatches(status, [
                CareerStatuses[CAREER_STATUS_UNLEARNED], // 未学習
                CareerStatuses[CAREER_STATUS_LEARNING], // 学習中
                CareerStatuses[CAREER_STATUS_DOING], // 実施中(学習中として扱う)
            ]);
        case CareerStatusType.ALL: // すべて
        default:
            return true;
    }
};
const filterCareers = (careers: { onGoing: OnGoingGridListItem[] }, categories: Categories, categoryValue: string, statusValue: string) =>
    (careers.onGoing || [])
        // フィルタリング
        .filter((career) => filterByCategory(career, categories, categoryValue) && filterByStatus(career, statusValue))
        // ソート
        .sort((a, b) =>
            chainedSort(
                a,
                b,
                // 1 必須⇒任意
                (_a, _b) => {
                    const { compulsoryId: compulsoryIdA } = _a;
                    const { compulsoryId: compulsoryIdB } = _b;
                    return sortByRequired(compulsoryIdA, compulsoryIdB);
                },

                // 2 受講期間開始日、降順
                (_a, _b) => {
                    const parse = (c: OnGoingGridListItem) => {
                        const { jissiStartDateODT } = c;
                        return parseJSDateTime(jissiStartDateODT, DateFormats.YYYYMMDDHHMM);
                    };
                    const endA = parse(_a);
                    const endB = parse(_b);
                    return descDate(endA, endB);
                },

                // 3 表示期間開始日、降順
                (_a, _b) => {
                    const parse = (c: OnGoingGridListItem) => {
                        const { displayStartDateTime } = c;
                        return parseJSDateTime(displayStartDateTime, DateFormats.YYYYMMDDHHMM);
                    };
                    const startA = parse(_a);
                    const startB = parse(_b);
                    return descDate(startA, startB);
                },

                // 4 講座名、昇順
                (_a, _b) => asc(_a.careerTitle, _b.careerTitle)
            )
        );

const OnGoing = (props: { categories: Categories; histories: Histories }) => {
    // Context.
    const sompoContext = React.useContext(SompoContext); // ローディングアニメーションの表示用

    const { categories, histories } = props;
    // console.log("onGoingタブ: histories", histories.careers.onGoing);
    const { getLevelCategories } = categories;
    const conditionList = ConditionList(getLevelCategories(CATEGORY_ID_CAREERS));

    const navigate = useNavigate();
    const { desktop } = useScreenSize();
    const [careers, setCareers] = useState<OnGoingGridListItem[]>([]);
    const [mobileCareers, setMobileCareers] = useState<React.ReactNode[]>([]);

    const [categoryValue, setCategoryValue] = React.useState(ALL_CONDITION.id);
    const handleCategoryChange = (name: string, id: string) => {
        setCategoryValue(id);
    };

    // ラジオボタン選択時
    const [statusValue, setStatusValue] = React.useState(CareerStatusType.DOING); // ラジオボタン(初期値は受講中)
    const handleStatusChange = (event: { target: { value: string } }) => {
        const target = event.target.value;
        setStatusValue(target);
    };

    // カルーセルのドット数に応じて表示領域を可変にするために使用
    const carouselContainerHeight = calcDotsHeight(660, careers.length, ROWS);

    useEffect(() => {
        const filteredCareers = filterCareers(histories.careers, categories, categoryValue, statusValue);
        const mobileCards = toMobileCards(filteredCareers, navigate);

        setCareers(filteredCareers);
        setMobileCareers(mobileCards);
    }, [categoryValue, statusValue]);

    return (
        <>
            <Box
                sx={{
                    width: "100%",
                    height: "auto",
                    minHeight: "200px",
                    pointerEvents: sompoContext.loading ? "none" : "auto",
                }}
            >
                <FilterTag conditionList={conditionList} value={categoryValue} handleChange={handleCategoryChange} />
                <Grid item>
                    <FormControl
                        sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            justifyContent: "left",
                        }}
                    >
                        <RadioGroup row={true} defaultValue={CareerStatusType.ALL} value={statusValue} onChange={handleStatusChange}>
                            <FormControlLabel
                                value={CareerStatusType.ALL}
                                control={<Radio size="small" />}
                                label={<Typography variant="body2">すべて</Typography>}
                            />
                            <FormControlLabel
                                value={CareerStatusType.APPLYING}
                                control={<Radio size="small" />}
                                label={<Typography variant="body2">申請中</Typography>}
                            />
                            <FormControlLabel
                                value={CareerStatusType.DOING}
                                control={<Radio size="small" />}
                                label={<Typography variant="body2">受講中</Typography>}
                            />
                        </RadioGroup>
                    </FormControl>
                </Grid>
                {/* fetchが終わるまでローディングアイコンを表示 */}
                {sompoContext.loading ? (
                    <SompoLoading mt={5} position="relative" />
                ) : (
                    <>
                        <ScrollableGrid>
                            {careers && careers.length > 0 ? (
                                desktop ? (
                                    <>
                                        {careers.map((row) => {
                                            const el = row.careerTypeId === CAREER_TYPE_ELEARNING;
                                            const gt = row.careerTypeId === CAREER_TYPE_CLASSROOM;

                                            const { alertView, remainingDays } = alertDays(row);
                                            return (
                                                <Paper elevation={1} sx={{ mr: 1 }} key={`Home-OnGoing-Career-Card-Paper-${row.careerId}`}>
                                                    <CareerCard
                                                        height="305px"
                                                        key={`Home-OnGoing-Career-Card-${row.careerId}`}
                                                        thumbnail={row.careerImageUrl}
                                                        tooltip={row.careerTitle}
                                                        badge={row.compulsoryId}
                                                        onClick={() => {
                                                            navigate(`/training/detail/${row.careerId}`, {
                                                                state: { check: false, showCertification: true, classId: row.classId },
                                                            });
                                                        }}
                                                    >
                                                        <SompoCardContent
                                                            sx={{
                                                                display: "flex",
                                                                gap: 0.4,
                                                                flexFlow: "column",
                                                                justifyContent: "flex-start",
                                                                textAlign: "left",
                                                            }}
                                                        >
                                                            <Box />
                                                            <Typography
                                                                sx={{
                                                                    width: "100%",
                                                                    fontSize: "1rem",
                                                                    fontWeight: "bold",
                                                                    minHeight: "2lh",
                                                                    wordBreak: "break-all",
                                                                    overflowX: "hidden",
                                                                }}
                                                                className="ellipses2"
                                                            >
                                                                {row.careerTitle}
                                                            </Typography>
                                                            <SompoDeadlineAlert nearDeadline={alertView} diffDays={remainingDays} />
                                                            <Typography
                                                                variant="body2"
                                                                sx={{
                                                                    fontWeight: alertView ? "bold" : "normal",
                                                                    minHeight: "1.2em",
                                                                }}
                                                            >
                                                                {formatPeriod(row.jissiKikan)}
                                                            </Typography>
                                                            {el && <Typography variant="body2">eラーニング</Typography>}
                                                            {gt && <Typography variant="body2">集合研修</Typography>}
                                                            {gt && (
                                                                <Typography
                                                                    className="ellipses"
                                                                    variant="body2"
                                                                    sx={{ wordBreak: "break-all", overflowX: "hidden" }}
                                                                >
                                                                    {row.classroom}
                                                                </Typography>
                                                            )}
                                                            {el && <SompoProgressBar progress={row.progress} />}
                                                        </SompoCardContent>
                                                    </CareerCard>
                                                </Paper>
                                            );
                                        })}
                                    </>
                                ) : (
                                    <Grid sx={{ width: "100%", height: carouselContainerHeight, margin: "0 auto" }}>
                                        <SompoHistoryCarousel careers={mobileCareers} />
                                    </Grid>
                                )
                            ) : (
                                <NoData message="表示データがありません" />
                            )}
                        </ScrollableGrid>
                    </>
                )}
            </Box>
        </>
    );
};

export default OnGoing;
